import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Card, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const DetailPage = () => {
  const { testId } = useParams(); // Get testId from route parameters
  const rollno = localStorage.getItem("rollno"); // Get rollno from localStorage

  const [testData, setTestDetails] = useState([]); // State for test details
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(''); // Error state
  const [rno, setRno] = useState(''); 
  const [testFile, setTesFile] = useState([]); 
  // Fetch data from API
  useEffect(() => {
    
    setRno(rollno);
    const fetchDetails = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `https://testresult.omegacareerinstitute.com/admin/welcome/get_test_result?testId=${testId}&rollno=${rollno}`

        ); // Replace with your API endpoint
        const data = await response.json();

        if (data) {
          setTestDetails(data); // Set the fetched data to state
        } else {
          setError("Notice:You were absent for the test.");
        }
      } catch (err) {
        setError("Notice:You were absent for the test.");
       // setTestDetails();
      } finally {
        setLoading(false);
      }
    };


    const fetchNotice = async () => {
      try {
          setLoading(true);
  
          // Fetching data from the API
          const response = await fetch(
              `https://testresult.omegacareerinstitute.com/admin/welcome/get_test_notice?testId=${testId}&rollno=${rollno}`
          ); // Replace with your API endpoint
  
          const data = await response.json();
  
          // Check if the API response contains a message or test details
          if (data) {
              if (data.message) {
                  // If the API includes a message, display it
                  setError(data.message);
              } else {
                  // If valid test details are fetched, set them in state
                  setError('Notice:Your were absent in test.');
              }
          } else {
              // Handle cases where no valid data is returned
            
          }
      } catch (err) {
          // Handle any fetch or network errors
         
      } finally {
          // Always set loading to false when the operation is complete
          setLoading(false);
      }
  };

  const fetchfile = async () => {
    try {
        setLoading(true);

        // Fetching data from the API
        const response = await fetch(
            `https://testresult.omegacareerinstitute.com/admin/welcome/get_test_file?testId=${testId}`
        ); // Replace with your API endpoint

        const data = await response.json();
        setTesFile(data);
      
        // Check if the API response contains a message or test details
       
    } catch (err) {
        // Handle any fetch or network errors
       
    } finally {
        // Always set loading to false when the operation is complete
        setLoading(false);
    }
};
  
    fetchDetails();
    fetchfile();
    fetchNotice();
  }, [testId, rollno]);

  if (loading) {
    return <div className="text-center mt-4">Loading...</div>;
  }

  // if (error) {
  //   return <div className="text-center mt-4 text-danger">{error}</div>;
  // }

  return (
    <div className="container mt-4">
     
     
      
      <div className="row g-4">
        {/* Test Series Details Card */}
       

        {/* Test Result Card */}
        <div className="col-md-12">
     <Card className="shadow-lg border-0" style={{ borderRadius: "12px" }}>
  <Card.Body style={{ backgroundColor: "#f8f9fa" }}>

    {/* Header */}
    <div className="text-center mb-3">
      <h4 className="fw-bold" style={{fontSize:12}}>Test Result Summary</h4>
    </div>
{testData.length === 0 && (<div className="text-center mb-4 text-danger">{error}</div>
      )}
    {/* Priority Details */}
    <div className="p-3 mb-3" style={{ backgroundColor: "#e3f2fd", borderRadius: "10px" }}>
      <div className="row text-center">

        <div className="col">
          <h6 className="text-muted mb-1">Roll No</h6>
          <h5 className="fw-bold" style={{fontSize:12}}>{testData?.roll_no || "N/A"}</h5>
        </div>

        <div className="col"  >
          <h6 className="text-muted mb-1" >Test Code</h6>
          <h5 className="fw-bold" style={{fontSize:12}} >{testData?.name || "N/A"}</h5>
        </div>
        </div>
 
    </div>
   <div className="p-3 mb-3" style={{ backgroundColor: "#d8ddd6ff", borderRadius: "10px" }}>
     
 <div className="row text-center" >
        <div className="col" >
          <h6 className="text-muted mb-1">Rank</h6>
          <h5 className="fw-bold text-success" >{testData?.test_rank || "N/A"}</h5>
        </div>

        <div className="col"  >
          <h6 className="text-muted mb-1" >Total Marks</h6>
          <h5 className="fw-bold text-primary" >{testData?.total || "N/A"}</h5>
        </div>

      </div>
    </div>
    {/* Subject Section */}
    <h5 className="fw-bold text-center mb-3" style={{fontSize:12}}>Subject Wise Performance</h5>

    {/* Subject Box Component */}
    {[
      { title: "Physics", r: "phy_r", w: "phy_w", l: "phy_l", m: "phy_mk", color: "#ffecb3" },
      { title: "Chemistry", r: "chem_r", w: "chem_w", l: "chem_l", m: "chem_mk", color: "#e8f5e9" },
      { title: "Biology", r: "bio_r", w: "bio_w", l: "bio_l", m: "bio_mk", color: "#f3e5f5" }
    ].map((sub, i) => (
      <div key={i} className="p-1 mb-3" style={{ backgroundColor: sub.color, borderRadius: "10px" }}>
        <h6 className="fw-bold mb-1" style={{fontSize:12}}>{sub.title}</h6>
        <div className="row text-center">
          <div className="col"  style={{margin:0, padding:0}}>
            <strong>Right</strong><br />
            <span>{testData?.[sub.r] || 0}</span>
          </div>
          <div className="col" style={{margin:0, padding:0}}>
            <strong>Wrong</strong><br />
            <span >{testData?.[sub.w] || 0}</span>
          </div>
          <div className="col" style={{margin:0, padding:0}}>
            <strong >Left</strong><br />
            <span >{testData?.[sub.l] || 0}</span>
          </div>
          <div className="col" style={{margin:0, padding:0}}>
            <strong >Marks</strong><br />
            <span className="fw-bold" >{testData?.[sub.m] || 0}</span>
          </div>
        </div>
      </div>
    ))}

    {/* Entry Date */}
    <div className="text-end text-muted mt-3">
      <small> Date: {testData?.entryDate || "N/A"}</small>
    </div>

  </Card.Body>
</Card>

        </div>
    
        {/* Action Buttons Card */}
        <div className="col-md-12">
          <Card className="shadow" style={{ backgroundColor: "#d1e7dd" }}>
            <Card.Body>
              <Card.Title className="text-center">Actions</Card.Title>
              <div className="d-flex flex-column align-items-center gap-2">
                <Button as={Link}  to={`/omrsheet/${testId}/${testData?.name}`} variant="primary" className="w-100">
                  OMR Sheet
                </Button>
                <Button as={Link}  to={`/response/${testId}/${testData?.name}`} variant="success" className="w-100">
                  Response Result
                </Button>
               

               
                <Button 
  variant="primary" 
  className="w-100"
  onClick={() => window.open(`https://docs.google.com/gview?embedded=true&url=https://testresult.omegacareerinstitute.com/admin/testpaper/${testFile.top_30}`, '_blank')}
>
Top 30 Rank
</Button>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default DetailPage;
